export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/faces/kaci-baum-1-a8ccaf0129c17e68dfeeef068f313369.jpg";